import type { StatusTransMap } from "components/table";
import type { LeadCounts, LeadSource, LeadStatus } from "types/lead";
import type { BadgeTone } from "views/Opportunity/opportunity.meta";

export const LEAD_PATH = "/lead";

export const leadStatusTrans: StatusTransMap<LeadStatus> = {
  PENDING: { label: "Chờ xử lý", color: "#b54708", bgcolor: "#fdead7" },
  COMPLETE: { label: "Hoàn thành", color: "#027a48", bgcolor: "#d1fadf" },
};

export const leadSourceLabel: Record<LeadSource, string> = {
  SEO: "SEO",
  CUSTOMER_REFERRAL: "Khách hàng khác giới thiệu",
};

export const leadSourceOptions: { label: string; value: LeadSource }[] = [
  { label: "SEO", value: "SEO" },
  { label: "Khách hàng khác giới thiệu", value: "CUSTOMER_REFERRAL" },
];

export const leadStatusOptions: { label: string; value: LeadStatus }[] = [
  { label: "Chờ xử lý", value: "PENDING" },
  { label: "Hoàn thành", value: "COMPLETE" },
];

export const leadTabs: { key: string; label: string; tone: BadgeTone }[] = [
  { key: "ALL", label: "Tất cả", tone: "blue" },
  { key: "PENDING", label: "Chờ xử lý", tone: "orange" },
  { key: "COMPLETE", label: "Hoàn thành", tone: "green" },
];

export const emptyLeadCounts = (): LeadCounts => ({
  all: 0,
  statuses: { PENDING: 0, COMPLETE: 0 },
});

export const parseLeadLinks = (fromLink?: string | null): string[] => {
  const raw = (fromLink || "").trim();
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.map((item) => String(item ?? "").trim()).filter(Boolean);
    }
  } catch {
    return [raw];
  }

  return [raw];
};
